@if (isGoogleMapInitialized() && mapId()) {
  <div class="element-wrapper {{ elementKey() }}" [ngStyle]="wrapperStyles()">
    <div class="header">
      <blaze-element-filter-header
        [addButtonEnabled]="false"
        [fontColor]="titleFontColor()"
        [labelEnabled]="labelEnabled()"
        [labelFontFamily]="props?.style?.titleBlock?.fontFamily"
        [labelFontSize]="props?.style?.titleBlock?.fontSize"
        [labelFontStyle]="props?.style?.titleBlock?.fontStyle"
        [labelFontWeight]="props?.style?.titleBlock?.fontWeight"
        [labelIconAlign]="props?.content?.title?.iconPosition"
        [labelIconSize]="props?.style?.titleBlock?.iconSize"
        [labelIconColor]="props?.content?.title?.iconColor?.color1"
        [labelIcon]="title()?.icon"
        [labelTextAlign]="props?.content?.title?.align"
        [labelText]="labelText()"
        [searchAndFilters]="props?.content?.searchAndFilters"
        [slots]="slots"
      />
    </div>
    <div class="flex flex-col w-full h-full relative gap-16 left-0 top-0">
      <div class="flex-1 relative">
        <be-google-map
          [center]="center()"
          [zoom]="zoom()"
          [options]="options()"
          [mapId]="mapId()"
          (mousedown)="onMouseDown($event)"
        >
          <be-map-marker-clusterer [enabled]="markerClustering()">
            @for (marker of markers(); track marker.id) {
              <be-map-advanced-marker
                [id]="marker.id"
                [position]="marker.position"
                (markerClick)="openInfoWindow($event.marker, marker)"
              >
                <be-map-marker
                  [marker]="marker"
                  [selected]="marker.id === selectedMarkerId()"
                  [style]="markerStyle()"
                  [cssStyles]="props?.style?.marker"
                />
              </be-map-advanced-marker>
            }
          </be-map-marker-clusterer>
          <be-map-info-window class="{{ elementActionsKeyRoot }} {{ elementActionsKey() }}">
            @if (selectedMarker(); as marker) {
              @if (marker.fields.card && marker.fields.card.title) {
                <be-map-card
                  [datasetRow]="marker.item"
                  [tagConfig]="tagConfig()"
                  [card]="marker.fields.card"
                  [cssStyle]="props?.style?.card"
                  [getActionClasses]="getActionClasses"
                  (action)="onCardAction(marker, $event)"
                />
              }
            }
          </be-map-info-window>
        </be-google-map>
      </div>
    </div>
  </div>
}
